export default __webpack_public_path__ + "static/media/title_vi_sp.cfffd51e.png";